/* =========================================================================
   ENDEX GROUP — endex-scenes.js | Pinned 3D scroll scenes beyond the homepage
   ARMORY    (shop / collection pages) The collection's own products fly in
             from deep space and lock into a 3D ring. Scrolling spins the ring
             a full turn while the camera tilts; whichever product faces you
             lights up and its name, price and number scramble into the
             readout. At the end the ring blows outward and hands you to the
             grid. The front product is a real link.
   TEARDOWN  (product pages) The product photo tilts into an isometric 3D
             plane, splits into a 4x5 grid of blocks that lift to different
             heights, an orange scan plane passes through, and callouts with
             leader lines point at the blocks carrying the product's real
             specs. The stack turns, reassembles, and stamps "all accounted for".
   Both are pure functions of scroll progress (identical forwards and back),
   pinned with ScrollTrigger like the homepage sections, built only from DOM
   already on the page, and skipped entirely under reduced motion.
   ========================================================================= */
(function(){
  'use strict';
  var html=document.documentElement;
  var REDUCE=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SIG=(window.EndexFXConfig&&window.EndexFXConfig.sig)||'#FF5A1F';
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var clamp=function(v,a,b){return v<a?a:v>b?b:v;};
  var lerp=function(a,b,t){return a+(b-a)*t;};
  var seg=function(p,a,b){return clamp((p-a)/(b-a),0,1);};
  var eio=function(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;};
  var eo=function(t){return 1-Math.pow(1-t,3);};
  function el(tag,cls,parent,h){var e=document.createElement(tag);if(cls)e.className=cls;if(h!=null)e.innerHTML=h;if(parent)parent.appendChild(e);return e;}
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  var GLYPHS='\u2593\u2592\u2591\u2588#/<>_-=+01';
  function scramble(node,text,dur){
    text=text==null?node.textContent:text; if(node._s)cancelAnimationFrame(node._s); var t0=performance.now();
    (function f(now){var p=Math.min(1,(now-t0)/dur),rev=Math.floor(p*text.length*1.15),s='';
      for(var i=0;i<text.length;i++)s+=(i<rev||text[i]===' ')?text[i]:GLYPHS[(Math.random()*GLYPHS.length)|0];
      node.textContent=s; if(p<1)node._s=requestAnimationFrame(f);else node.textContent=text;})(t0);
  }
  function srcOf(img){if(!img)return '';return img.currentSrc||img.getAttribute('src')||((img.getAttribute('srcset')||'').split(',').pop()||'').trim().split(' ')[0]||'';}

  var CSS=
  /* ---- ARMORY ---- */
  '.fxa{position:relative;background:#070706;color:#F4F1EA;overflow:hidden}'+
  '.fxa__pin{position:relative;height:100vh;height:100svh;overflow:hidden}'+
  '.fxa__pin::before{content:"";position:absolute;inset:0;pointer-events:none;opacity:.8;background-image:linear-gradient(rgba(244,241,234,.07) 1px,transparent 1px),linear-gradient(90deg,rgba(244,241,234,.07) 1px,transparent 1px);background-size:12.5vw 12.5vw;background-position:-1px -1px}'+
  '.fxa__stage{position:absolute;inset:0;perspective:1100px;perspective-origin:50% 42%}'+
  '.fxa__cam{position:absolute;left:50%;top:48%;width:0;height:0;transform-style:preserve-3d}'+
  '.fxa__ring{position:absolute;left:0;top:0;transform-style:preserve-3d}'+
  '.fxa__floor{position:absolute;left:0;top:0;transform-style:preserve-3d}'+
  '.fxa__floor i{position:absolute;border:1px solid rgba(244,241,234,.16);border-radius:50%}'+
  '.fxa__floor i.s{border-color:rgba(255,90,31,.55);border-style:dashed}'+
  '.fxa__card{position:absolute;display:block;color:inherit;text-decoration:none;background:#141412;border:1px solid rgba(244,241,234,.22);transform-style:preserve-3d;backface-visibility:visible}'+
  '.fxa__card img{width:100%;height:100%;object-fit:cover;display:block;pointer-events:none}'+
  '.fxa__card.on{border-color:'+SIG+';box-shadow:0 0 0 1px '+SIG+',0 30px 80px -20px rgba(255,90,31,.45)}'+
  '.fxa__card b{position:absolute;left:8px;top:8px;font:500 9px/1 "JetBrains Mono",monospace;letter-spacing:.16em;color:#F4F1EA;background:rgba(7,7,6,.7);padding:4px 5px}'+
  '.fxa__hud{position:absolute;inset:0;pointer-events:none;z-index:3}'+
  '.fxa__k{position:absolute;left:var(--gut,20px);top:calc(var(--hdr-h,64px) + 14px);font:500 10px/1.4 "JetBrains Mono",monospace;letter-spacing:.2em;text-transform:uppercase;color:rgba(244,241,234,.75)}'+
  '.fxa__k b{color:'+SIG+';font-weight:500}'+
  '.fxa__h{position:absolute;left:var(--gut,20px);top:calc(var(--hdr-h,64px) + 40px);margin:0;font:600 clamp(2.6rem,9vw,8.6rem)/.86 "Chakra Petch","Archivo",sans-serif;text-transform:uppercase;letter-spacing:-.01em;max-width:11ch}'+
  '.fxa__rd{position:absolute;left:var(--gut,20px);right:var(--gut,20px);bottom:26px;display:flex;justify-content:space-between;align-items:flex-end;gap:16px}'+
  '.fxa__nm{font:600 clamp(1.3rem,3vw,2.4rem)/1 "Chakra Petch","Archivo",sans-serif;text-transform:uppercase;max-width:18ch}'+
  '.fxa__pr{display:block;margin-top:8px;font:500 11px/1 "JetBrains Mono",monospace;letter-spacing:.16em;color:'+SIG+'}'+
  '.fxa__ix{font:500 10px/1.6 "JetBrains Mono",monospace;letter-spacing:.2em;text-transform:uppercase;color:rgba(244,241,234,.7);text-align:right}'+
  '.fxa__bar{position:absolute;left:0;right:0;bottom:0;height:2px;background:rgba(244,241,234,.1)}'+
  '.fxa__bar i{position:absolute;inset:0;background:'+SIG+';transform-origin:left;transform:scaleX(0)}'+
  '.fxa__tap{pointer-events:auto}'+
  '@media(max-width:699px){.fxa__h{top:calc(var(--hdr-h,64px) + 36px)}.fxa__rd{bottom:20px}}'+
  /* ---- TEARDOWN ---- */
  '.fxt{position:relative;background:#070706;color:#F4F1EA;overflow:hidden;border-top:1px solid rgba(244,241,234,.12)}'+
  '.fxt__pin{position:relative;height:100vh;height:100svh;overflow:hidden}'+
  '.fxt__stage{position:absolute;inset:0;perspective:1400px;perspective-origin:50% 40%}'+
  '.fxt__plane{position:absolute;left:50%;top:52%;transform-style:preserve-3d}'+
  '.fxt__sl{position:absolute;transform-style:preserve-3d}'+
  '.fxt__sl i{position:absolute;inset:0;background:#1a1a17;border:1px solid rgba(244,241,234,.06)}'+
  '.fxt__sl .f{background-repeat:no-repeat;border:0}'+
  '.fxt__sl .e{background:'+SIG+';opacity:0}'+
  '.fxt__scan{position:absolute;left:-12%;top:-12%;width:124%;height:124%;background:linear-gradient(90deg,rgba(255,90,31,0),rgba(255,90,31,.16),rgba(255,90,31,0));border:1px solid rgba(255,90,31,.6);opacity:0;pointer-events:none}'+
  '.fxt__svg{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:2;overflow:visible}'+
  '.fxt__svg line{stroke:'+SIG+';stroke-width:1}'+
  '.fxt__svg circle{fill:'+SIG+'}'+
  '.fxt__co{position:absolute;z-index:3;max-width:min(42vw,220px);font:500 10px/1.5 "JetBrains Mono",monospace;letter-spacing:.16em;text-transform:uppercase;opacity:0;pointer-events:none}'+
  '.fxt__co b{display:block;color:'+SIG+';font-weight:500;margin-bottom:4px}'+
  '.fxt__co span{color:#F4F1EA;letter-spacing:.08em;text-transform:none;font-size:12px;font-family:"Archivo",system-ui,sans-serif}'+
  '.fxt__k{position:absolute;left:var(--gut,20px);top:calc(var(--hdr-h,64px) + 14px);z-index:3;font:500 10px/1.4 "JetBrains Mono",monospace;letter-spacing:.2em;text-transform:uppercase;color:rgba(244,241,234,.75)}'+
  '.fxt__k b{color:'+SIG+';font-weight:500}'+
  '.fxt__h{position:absolute;left:var(--gut,20px);top:calc(var(--hdr-h,64px) + 38px);z-index:3;margin:0;font:600 clamp(2rem,6vw,5.4rem)/.88 "Chakra Petch","Archivo",sans-serif;text-transform:uppercase;max-width:12ch}'+
  '.fxt__ft{position:absolute;left:var(--gut,20px);right:var(--gut,20px);bottom:24px;z-index:3;display:flex;justify-content:space-between;font:500 10px/1.4 "JetBrains Mono",monospace;letter-spacing:.2em;text-transform:uppercase;color:rgba(244,241,234,.7)}'+
  '.fxt__stamp{position:absolute;left:50%;top:52%;z-index:4;transform:translate(-50%,-50%) rotate(-8deg);padding:10px 16px 9px;border:3px solid '+SIG+';color:'+SIG+';font:700 clamp(1.4rem,4vw,2.6rem)/1 "Chakra Petch","Archivo",sans-serif;text-transform:uppercase;white-space:nowrap;opacity:0;pointer-events:none}'+
  '.fxt__stamp::before{content:"";position:absolute;inset:3px;border:1px solid '+SIG+'}';

  /* ============================================================== ARMORY */
  function armory(){
    if(!document.body.classList.contains('template-collection'))return;
    var grid=$('main .grid'); if(!grid)return;
    var cards=$$('.card',grid).filter(function(c){return $('.card__media img',c);});
    if(cards.length<3)return;
    var data=cards.slice(0,12).map(function(c){
      var a=$('.card__title a',c)||$('a',c), pr=$('.price',c)||$('[class*="price"]',c);
      return {img:srcOf($('.card__media img',c)),title:(a&&a.textContent||'').trim(),url:a&&a.getAttribute('href')||'#',price:(pr&&pr.textContent||'').replace(/\s+/g,' ').trim()};
    });
    var n=data.length; while(data.length<8)data=data.concat(data.slice(0,n)); data=data.slice(0,Math.max(8,n));
    var N=data.length;
    var host=grid.closest('.shopify-section')||grid.closest('section');
    var titleEl=$('h1',host), title=(titleEl&&titleEl.textContent||'The armory').trim();
    var sec=el('section','fxa fx-own'); sec.setAttribute('aria-label','Collection preview');
    host.parentNode.insertBefore(sec,host);
    var pin=el('div','fxa__pin',sec);
    var stage=el('div','fxa__stage',pin), cam=el('div','fxa__cam',stage), floor=el('div','fxa__floor',cam), ring=el('div','fxa__ring',cam);
    var rings=[0,1,2,3].map(function(k){var r=el('i',k===1?'s':'',floor);return r;});
    var items=data.map(function(d,i){
      var a=el('a','fxa__card',ring,'<img alt="" loading="eager" src="'+esc(d.img)+'"><b>'+String((i%n)+1).padStart(2,'0')+'</b>');
      a.href=d.url; a.setAttribute('tabindex','-1'); a.setAttribute('aria-hidden','true'); return a;
    });
    var hud=el('div','fxa__hud',pin);
    var k=el('div','fxa__k',hud,'<b>\u25B8</b> The armory // '+String(n).padStart(2,'0')+' items');
    var h=el('h2','fxa__h',hud,esc(title));
    var rd=el('div','fxa__rd',hud,'<a class="fxa__tap" href="#"><span class="fxa__nm"></span><span class="fxa__pr"></span></a><div class="fxa__ix"><span data-i></span><br>Scroll to rotate</div>');
    var tap=$('.fxa__tap',rd), nm=$('.fxa__nm',rd), pr=$('.fxa__pr',rd), ix=$('[data-i]',rd);
    tap.style.color='inherit'; tap.style.textDecoration='none';
    var bar=el('div','fxa__bar',pin,'<i></i>'), barI=bar.firstChild;
    var active=-1, P=0;
    function size(){
      var W=pin.clientWidth,H=pin.clientHeight, cw=W<700?Math.min(W*.36,170):Math.min(W*.17,280), ch=cw*1.25;
      var R=W<700?Math.max(W*.62,cw*N/5.2):Math.max(Math.min(W*.36,560),cw*N/5.8);
      items.forEach(function(a){a.style.width=cw+'px';a.style.height=ch+'px';a.style.marginLeft=(-cw/2)+'px';a.style.marginTop=(-ch/2)+'px';});
      rings.forEach(function(r,i){var rr=R*(.55+i*.28);r.style.width=r.style.height=(rr*2)+'px';r.style.marginLeft=r.style.marginTop=(-rr)+'px';});
      return {W:W,H:H,R:R,cw:cw,ch:ch};
    }
    var S=size();
    function layout(){
      var p=P, intro=seg(p,0,.2), spin=seg(p,.12,.84), out=eio(seg(p,.84,1));
      var rot=-eio(spin)*360+(1-eo(intro))*-40;
      var tilt=lerp(-16,8,eio(spin))*(1-out)+out*-24;
      cam.style.transform='translateZ('+(-S.R*.9-out*S.R*.4)+'px) rotateX('+tilt+'deg)';
      ring.style.transform='rotateY('+rot+'deg)';
      floor.style.transform='translateY('+(S.ch*.62)+'px) rotateX(90deg) rotateZ('+(-rot*.5)+'deg)';
      floor.style.opacity=eo(intro)*(1-out);
      var best=-1,bestC=-2;
      items.forEach(function(a,i){
        var ang=i*360/N, fi=eo(seg(intro,i/N*.5,.5+i/N*.5)),
            z=S.R*(1+out*1.6)-(1-fi)*1600, y=-out*(i%2?1:-1)*S.H*.25;
        a.style.transform='rotateY('+ang+'deg) translateZ('+z+'px) translateY('+y+'px) rotateY('+((1-fi)*180)+'deg)';
        var c=Math.cos((ang+rot)*Math.PI/180);
        a.style.opacity=(fi*(.22+.78*Math.max(0,c)))*(1-out);
        if(c>bestC){bestC=c;best=i;}
      });
      if(best!==active){
        if(active>=0)items[active].classList.remove('on');
        active=best; items[best].classList.add('on');
        var d=data[best]; scramble(nm,d.title.toUpperCase(),380); scramble(pr,d.price||'',300);
        ix.textContent=String((best%n)+1).padStart(2,'0')+' / '+String(n).padStart(2,'0'); tap.href=d.url;
      }
      h.style.opacity=1-seg(p,.12,.3); h.style.transform='translateY('+(-seg(p,.12,.3)*30)+'px)';
      rd.style.opacity=seg(p,.12,.24)*(1-out);
      k.style.opacity=1-out*.8;
      barI.style.transform='scaleX('+p+')';
    }
    ScrollTrigger.create({trigger:pin,start:'top top',end:'+=260%',pin:true,scrub:true,
      onUpdate:function(s){P=s.progress;layout();},onRefresh:function(s){S=size();P=s.progress;layout();}});
    // intro title scramble after any page transition
    (window.EndexTxReady||Promise.resolve()).then(function(){scramble(h,title.toUpperCase(),700);});
    layout();
  }

  /* ============================================================ TEARDOWN */
  function teardown(){
    var main=$('.pdp__main'); if(!main)return;
    var img=$('.pdp__frame.is-active img',main)||$('img',main); var src=srcOf(img); if(!src)return;
    var host=main.closest('.shopify-section')||main.closest('section'); if(!host)return;
    var specs=$$('.spec__row').map(function(r){var k=$('.spec__k',r),v=$('.spec__v',r);return {k:(k&&k.textContent||'').trim(),v:(v&&(v.dataset.t||v.textContent)||'').trim()};}).filter(function(s){return s.k&&s.v;});
    var fall=[{k:'Build',v:'Made to order'},{k:'Print',v:'Printed when you buy'},{k:'Issue',v:'Numbered drop'},{k:'Standard',v:'Built after dark'}];
    while(specs.length<4)specs.push(fall[specs.length]);
    specs=specs.slice(0,4);
    var ttl=($('.pdp__title')||{}).textContent||'';
    var sec=el('section','fxt fx-own'); sec.setAttribute('aria-hidden','true');
    host.parentNode.insertBefore(sec,host.nextSibling);
    var pin=el('div','fxt__pin',sec), stage=el('div','fxt__stage',pin), plane=el('div','fxt__plane',stage);
    var C=4,Rw=5, slices=[], hts=[];
    for(var y=0;y<Rw;y++)for(var x=0;x<C;x++){
      var s=el('div','fxt__sl',plane,'<i style="transform:translateZ(-14px)"></i><i style="transform:translateZ(-7px)"></i><i class="e"></i><i class="f"></i>');
      var f=s.lastChild; f.style.backgroundImage='url("'+src.replace(/"/g,'%22')+'")'; f.style.backgroundSize=(C*100)+'% '+(Rw*100)+'%'; f.style.backgroundPosition=(x/(C-1)*100)+'% '+(y/(Rw-1)*100)+'%';
      s._x=x; s._y=y; slices.push(s);
      // heights: a smooth ridge rather than noise, so the lifted stack reads like terrain
      hts.push(.25+.75*Math.abs(Math.sin(x*1.3+y*.9)*Math.cos(y*.7-x*.4)));
    }
    var scanEl=el('div','fxt__scan',plane);
    var svg=document.createElementNS('http://www.w3.org/2000/svg','svg'); svg.setAttribute('class','fxt__svg'); pin.appendChild(svg);
    var targets=[1,6,13,18], cos=specs.map(function(sp,i){
      var co=el('div','fxt__co',pin,'<b>'+String(i+1).padStart(2,'0')+' // '+esc(sp.k)+'</b><span>'+esc(sp.v)+'</span>');
      var ln=document.createElementNS('http://www.w3.org/2000/svg','line'), dot=document.createElementNS('http://www.w3.org/2000/svg','circle'); dot.setAttribute('r','3');
      svg.appendChild(ln); svg.appendChild(dot); return {co:co,ln:ln,dot:dot,t:slices[targets[i]],side:i%2,row:i<2?0:1};
    });
    var kk=el('div','fxt__k',pin,'<b>\u25B8</b> Teardown // exploded view');
    var hh=el('h2','fxt__h',pin,esc(ttl.trim()));
    var ft=el('div','fxt__ft',pin,'<span data-l>Layer 00 / 20</span><span data-p>000%</span>'), lEl=$('[data-l]',ft), pEl=$('[data-p]',ft);
    var stamp=el('div','fxt__stamp',pin,'All accounted for');
    var P=0,S;
    function size(){
      var W=pin.clientWidth,H=pin.clientHeight,pw=W<700?Math.min(W*.62,300):Math.min(W*.3,420),ph=pw*1.25,cw=pw/C,chh=ph/Rw;
      plane.style.width=pw+'px'; plane.style.height=ph+'px'; plane.style.marginLeft=(-pw/2)+'px'; plane.style.marginTop=(-ph/2)+'px';
      slices.forEach(function(s){s.style.left=(s._x*cw)+'px';s.style.top=(s._y*chh)+'px';s.style.width=(cw+.5)+'px';s.style.height=(chh+.5)+'px';});
      return {W:W,H:H,pw:pw,ph:ph,mob:W<700};
    }
    S=size();
    function layout(){
      var p=P, tilt=eio(seg(p,0,.2)), lift=eio(seg(p,.16,.46)), spin=eio(seg(p,.44,.76)), back=eio(seg(p,.8,.95)), keep=1-back;
      plane.style.transform='rotateX('+(tilt*56*keep)+'deg) rotateZ('+((tilt*-32+spin*90)*keep)+'deg) scale('+(1-tilt*.1*keep)+')';
      var lifted=0;
      slices.forEach(function(s,i){
        var st=seg(lift,(i/slices.length)*.4,.6+(i/slices.length)*.4), zz=eo(st)*hts[i]*(S.mob?110:170)*keep;
        s.style.transform='translateZ('+zz.toFixed(1)+'px)';
        s.children[2].style.opacity=(st>0&&st<1?.9:0)*keep;   // orange edge while each block is rising
        if(st>.5)lifted++;
      });
      var sp=seg(p,.46,.74); scanEl.style.opacity=(sp>0&&sp<1)?Math.sin(sp*Math.PI):0;
      scanEl.style.transform='translateZ('+lerp(-20,(S.mob?130:200),sp)+'px)';
      // callouts: each pinned to its block's live on-screen position
      var pr=pin.getBoundingClientRect();
      cos.forEach(function(c,i){
        var a=seg(p,.3+i*.05,.38+i*.05)*(1-seg(p,.76,.82));
        c.co.style.opacity=a;
        var r=c.t.lastChild.getBoundingClientRect(), tx=r.left+r.width/2-pr.left, ty=r.top+r.height/2-pr.top;
        var bx=c.side?S.W-(S.mob?16:S.W*.08)-c.co.offsetWidth:(S.mob?16:S.W*.08), by=c.row?S.H*(S.mob?.74:.7):S.H*(S.mob?.3:.3);
        c.co.style.left=bx+'px'; c.co.style.top=by+'px';
        var ax=c.side?bx-8:bx+c.co.offsetWidth+8, ay=by+10;
        c.ln.setAttribute('x1',ax);c.ln.setAttribute('y1',ay);c.ln.setAttribute('x2',lerp(ax,tx,a));c.ln.setAttribute('y2',lerp(ay,ty,a));
        c.ln.style.opacity=a; c.dot.setAttribute('cx',tx); c.dot.setAttribute('cy',ty); c.dot.style.opacity=a;
      });
      hh.style.opacity=1-seg(p,.1,.24);
      var so=seg(p,.9,.96); stamp.style.opacity=so; stamp.style.transform='translate(-50%,-50%) rotate(-8deg) scale('+lerp(2.2,1,eo(so))+')';
      lEl.textContent='Layer '+String(lifted).padStart(2,'0')+' / 20'; pEl.textContent=String(Math.round(p*100)).padStart(3,'0')+'%';
    }
    ScrollTrigger.create({trigger:pin,start:'top top',end:'+=280%',pin:true,scrub:true,
      onUpdate:function(s){P=s.progress;layout();},onRefresh:function(s){S=size();P=s.progress;layout();}});
    layout();
  }

  function boot(){
    if(REDUCE||!window.gsap||!window.ScrollTrigger||!html.classList.contains('fx-on'))return;
    var st=document.createElement('style');st.textContent=CSS;document.head.appendChild(st);
    [armory,teardown].forEach(function(f){try{f();}catch(e){console.warn('[endex-scenes]',f.name,e);}});
    ScrollTrigger.sort&&ScrollTrigger.sort(); ScrollTrigger.refresh();
  }
  function go(){setTimeout(boot,0);}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',go):go();
})();
